module.exports = __webpack_public_path__ + "static/media/link-external.0f388cf6.svg";